module.exports = "/images/trail-2.jpg";